$(function () {
    $(document).on('click', '.txt-cta__wrapper__content__more', function () {
        $(this).hide();
        $('.txt-cta__wrapper__content__less').css('display', 'inline-block');
        var parentTag = $(this).parents().first('.txt-cta__wrapper__content');
        $('.txt-cta__wrapper__content__item:not(.txt-cta__wrapper__content__item--1):not(.txt-cta__wrapper__content__item--2)', parentTag).slideDown();
    });

    $(document).on('click', '.txt-cta__wrapper__content__less', function () {
        $(this).hide();
        $('.txt-cta__wrapper__content__more').css('display', 'inline-block');
        var parentTag = $(this).parents().first('.txt-cta__wrapper__content');
        $('.txt-cta__wrapper__content__item:not(.txt-cta__wrapper__content__item--1):not(.txt-cta__wrapper__content__item--2)', parentTag).slideUp();

        $('html, body').animate({
            scrollTop: $(parentTag).offset().top,
        }, 500, 'swing');
    });

    $(window).on('resize', function() {
        if (screen.width > 991) {
            $('.txt-cta__wrapper__content__less').hide();
            $('.txt-cta__wrapper__content__more').css('display', 'inline-block');
            $('.txt-cta__wrapper__content__item').removeAttr('style');
        }
    });
});
